import React from 'react'

const defaultItemsPerRow = 3;

// create a bootstrap grid, valid perRow is one of: 1,2,3,4,6,12
export function makeGrids(perRow = defaultItemsPerRow, elems, useColWidth = false) {
  var rows = [];
  var i = 0;
  var j = 0;
  var subArray = elems.slice(i, i + perRow);
  const cols = useColWidth ? '' : `col-md-${12 / perRow}`;
  while (i < elems.length) {
    rows.push(<div key={j++} className="row">
      {subArray.map((item, i) => {return useColWidth ? item : <div key={i} className={cols}>{item}</div>} )}
    </div>)
    i += perRow;
    subArray = elems.slice(i, i + perRow);
  }
  return rows;
}

function getFieldWidth(field, perRow = defaultItemsPerRow){
  return field.col_width || (12 / perRow)
}

export function getFieldWidthClass(field, perRow){
  return `col-xs-12 col-sm-${getFieldWidth(field, perRow)}`
}



// WEBPACK FOOTER //
// ./src/helpers/makeGrids.js